import { Box, Card, Typography } from '@mui/material'
import { STARTSurveyDisplay } from '../../../../customComponents/survey/STARTSurveyDisplay'
import { generatePath, useLocation, useNavigate, useParams } from 'react-router-dom'
import { SurveyType } from '../../../../../models/SurveySchema'
import { AppRoutes } from '../../../../Routes'
import { ImplementationDetailsTabs } from '../../ImplementationDetails'
import { styles } from './MidYear.styles'
import { useProgressReportAccess } from '../../../../../hooks/use-progressReportAccess'

export function MidYear (): JSX.Element {
  const { rcnId, planId, planOrgId } = useParams()
  const location = useLocation()
  const annualPlanId = planId != null ? Number(planId) : 0
  const planOrgIdNum = Number(planOrgId)
  const rcnIdNum = Number(rcnId)
  const nav = useNavigate()

  const { isLoading, surveyType } = useProgressReportAccess({
    annualPlanId,
    planOrgId: planOrgIdNum,
    rcnId: rcnIdNum,
    surveyTypeFromState: location.state?.surveyType,
    redirectPath: '..'
  })

  if (isLoading || surveyType == null) {
    return <div>Loading...</div>
  }

  const isRcn = surveyType === SurveyType.RCNMidYear
  const schemaId = surveyType

  const navigateToSummary = (): void => {
    if (rcnId == null || planId == null || planOrgId == null) return

    const path = generatePath(
      AppRoutes.IMPLEMENTATION_PROGRESS_REPORTS_ORGANIZATION_MIDYEAR_SUMMARY,
      {
        rcnId,
        planId,
        tab: String(ImplementationDetailsTabs.ProgressReports),
        planOrgId
      }
    )
    nav(path, { state: { surveyType } })
  }

  return (
    <Card sx={styles.card} data-testid='midYearReportCard'>

      <Box sx={styles.content}>
        <Box sx={styles.header}>
          <Typography variant='h1'>Progress Reports</Typography>
        </Box>

        <Typography variant='body1'>
          Share information about your progress toward your Implementation Plan with START at Mid-Year and End of Year by completing the Progress Reports.
        </Typography>

        <Box sx={styles.surveyContainer}>
          <STARTSurveyDisplay
            annualPlanId={annualPlanId}
            surveyType={schemaId}
            title={isRcn ? 'RCN Mid-Year' : 'ISD Progress on Contract Goals'}
            navigateToSummary={navigateToSummary}
            planOrgId={Number(planOrgId)}
          />
        </Box>
      </Box>
    </Card>
  )
}
